import {Injectable} from '@angular/core';

import {LocalStorageService} from './local-storage.service';
import {StoreKey} from "../../enums/local-store.enums";

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  public accessTokenKey: string = 'access_token';
  public refreshTokenKey: string = 'refresh_token';

  constructor(
     private readonly localStorageService: LocalStorageService
  ) {
  }

  getAccessToken(): string {
    return this.localStorageService.getData(StoreKey.ACCESS_TOKEN) as string;
  }

  saveAccessToken(token: string) {
    this.localStorageService.saveData(StoreKey.ACCESS_TOKEN, token);
  }

  getRefreshToken(): string {
    return this.localStorageService.getData(StoreKey.REFRESH_TOKEN) as string;
  }

  saveRefreshToken(token: string) {
    this.localStorageService.saveData(StoreKey.REFRESH_TOKEN, token);
  }

  saveTokens(accessToken: string, refreshToken: string) {
    this.saveAccessToken(accessToken);
    this.saveRefreshToken(refreshToken);
  }

  removeTokens() {
    this.localStorageService.deleteData(StoreKey.ACCESS_TOKEN);
    this.localStorageService.deleteData(StoreKey.REFRESH_TOKEN);
  }
}
